function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import FormattedAsset from "../Utility/FormattedAsset";
import { Link as RealLink } from "react-router-dom";
import Translate from "react-translate-component";
import counterpart from "counterpart";
import classNames from "classnames";
import { FormattedDate } from "react-intl";
import Inspector from "react-json-inspector";
import utils from "common/utils";
import { Icon as AntIcon } from "bitshares-ui-style-guide";
import LinkToAccountById from "../Utility/LinkToAccountById";
import LinkToAssetById from "../Utility/LinkToAssetById";
import FormattedPrice from "../Utility/FormattedPrice";
import account_constants from "chain/account_constants";
import Icon from "../Icon/Icon";
import PrivateKeyStore from "stores/PrivateKeyStore";
import WalletUnlockActions from "actions/WalletUnlockActions";
import ProposedOperation from "./ProposedOperation";
import { ChainTypes } from "bitsharesjs";
let {
  operations
} = ChainTypes;
import ReactTooltip from "react-tooltip";
import moment from "moment";
import { Link, DirectLink } from "react-scroll";
import { Tooltip } from "bitshares-ui-style-guide";
import JSONModal from "components/Modal/JSONModal";
import asset_utils from "../../lib/common/asset_utils";

require("./operations.scss");

require("./json-inspector.scss");

let ops = Object.keys(operations);
let listings = Object.keys(account_constants.account_listing);

const TranslateBoolean = ({
  value,
  ...otherProps
}) => /*#__PURE__*/React.createElement(Translate, _extends({
  content: `boolean.${value ? "true" : "false"}`
}, otherProps));

class OpType extends React.Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.type !== this.props.type;
  }

  render() {
    let trxTypes = counterpart.translate("transaction.trxTypes");
    let labelClass = classNames("txtlabel", this.props.color || "info");
    return /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", {
      className: labelClass
    }, this.props.txIndex >= 0 ? /*#__PURE__*/React.createElement("span", null, "#", this.props.txIndex + 1, ":\xA0") : "", trxTypes[ops[this.props.type]])), /*#__PURE__*/React.createElement("td", {
      className: "json-link",
      onClick: this.props.openJSONModal
    }, /*#__PURE__*/React.createElement(AntIcon, {
      type: "file-search"
    }), /*#__PURE__*/React.createElement(Translate, {
      component: "a",
      content: "transaction.view_json"
    })));
  }

}

class NoLinkDecorator extends React.Component {
  render() {
    return /*#__PURE__*/React.createElement("span", null, this.props.children);
  }

}

class OperationTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false
    };
  }

  openJSONModal = () => {
    this.setState({
      visible: true
    });
  };
  closeJSONModal = () => {
    this.setState({
      visible: false
    });
  };

  render() {
    const {
      operation
    } = this.props;
    let fee_row = /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
      component: "span",
      content: "transfer.fee"
    })), /*#__PURE__*/React.createElement("td", null, operation[1].fee.amount > 0 ? /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(FormattedAsset, {
      color: "fee",
      amount: operation[1].fee.amount,
      asset: operation[1].fee.asset_id,
      style: {
        marginRight: "10px"
      }
    }), "\xA0\xA0", /*#__PURE__*/React.createElement(Icon, {
      name: "question-circle",
      title: "settings.can_change_default_fee_asset_tooltip"
    })) : /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement(Translate, {
      content: "transfer.free"
    }))));
    const trxTypes = counterpart.translate("transaction.trxTypes");
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("table", {
      style: {
        marginBottom: "1em"
      },
      className: "table op-table"
    }, /*#__PURE__*/React.createElement("caption", null), /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement(OpType, {
      txIndex: this.props.txIndex,
      type: operation[0],
      color: this.props.color,
      openJSONModal: this.openJSONModal
    }), this.props.children, fee_row)), /*#__PURE__*/React.createElement(JSONModal, {
      visible: this.state.visible,
      operation: operation,
      title: trxTypes[ops[operation[0]] || ""],
      hideModal: this.closeJSONModal
    }));
  }

}

class Transaction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    ReactTooltip.rebuild();
  }

  linkToAccount(name_or_id) {
    if (!name_or_id) return /*#__PURE__*/React.createElement("span", null, "-");
    let Link = this.props.no_links ? NoLinkDecorator : RealLink;
    return utils.is_object_id(name_or_id) ? /*#__PURE__*/React.createElement(LinkToAccountById, {
      account: name_or_id
    }) : /*#__PURE__*/React.createElement(Link, {
      to: `/account/${name_or_id}/overview`
    }, name_or_id);
  }

  linkToAsset(symbol_or_id) {
    if (!symbol_or_id) return /*#__PURE__*/React.createElement("span", null, "-");
    let Link = this.props.no_links ? NoLinkDecorator : RealLink;
    return utils.is_object_id(symbol_or_id) ? /*#__PURE__*/React.createElement(LinkToAssetById, {
      asset: symbol_or_id
    }) : /*#__PURE__*/React.createElement(Link, {
      to: `/asset/${symbol_or_id}`
    }, symbol_or_id);
  }

  _toggleLock(e) {
    e.preventDefault();
    WalletUnlockActions.unlock().then(() => {
      this.forceUpdate();
    }).catch(() => {});
  }

  render() {
    let {
      trx
    } = this.props;
    let info = null;
    info = [];
    let opCount = trx.operations.length;
    let memo = null;
    trx.operations.forEach((op, opIndex) => {
      let rows = [];
      let key = 0;
      let color = "";

      switch (ops[op[0]] // For a list of trx types, see chain_types.coffee
      ) {
        case "transfer":
          color = "success";

          if (op[1].memo) {
            let {
              text,
              isMine
            } = PrivateKeyStore.decodeMemo(op[1].memo);
            memo = text ? /*#__PURE__*/React.createElement("td", {
              className: "memo",
              style: {
                wordBreak: "break-all"
              }
            }, text) : !text && isMine ? /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
              content: "transfer.memo_unlock"
            }), "\xA0", /*#__PURE__*/React.createElement("a", {
              onClick: this._toggleLock.bind(this)
            }, /*#__PURE__*/React.createElement(Icon, {
              name: "locked",
              title: "icons.locked.action"
            }))) : null;
          }

          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transfer.from"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].from))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transfer.to"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].to))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transfer.amount"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedAsset, {
            amount: op[1].amount.amount,
            asset: op[1].amount.asset_id
          }))));
          {
            memo ? rows.push( /*#__PURE__*/React.createElement("tr", {
              key: key++
            }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
              content: "transfer.memo"
            })), memo)) : null;
          }
          break;

        case "limit_order_create":
          color = "warning";
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "exchange.price"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedPrice, {
            base_asset: op[1].amount_to_sell.asset_id,
            quote_asset: op[1].min_to_receive.asset_id,
            base_amount: op[1].amount_to_sell.amount,
            quote_amount: op[1].min_to_receive.amount,
            noPopOver: true
          }))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "exchange.sell"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedAsset, {
            amount: op[1].amount_to_sell.amount,
            asset: op[1].amount_to_sell.asset_id
          }))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Tooltip, {
            placement: "left",
            title: counterpart.translate("tooltip.buy_min")
          }, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "exchange.buy_min"
          }))), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedAsset, {
            amount: op[1].min_to_receive.amount,
            asset: op[1].min_to_receive.asset_id
          })))); // rows.push(
          //     <tr key="2">
          //         <td><Translate component="span" content="transaction.min_receive" /></td>
          //         <td>{!missingAssets[1] ? <FormattedAsset amount={op[1].min_to_receive.amount} asset={op[1].min_to_receive.asset_id} /> : null}</td>
          //     </tr>
          // );

          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transaction.seller"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].seller))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transaction.expiration"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedDate, {
            value: moment.utc(op[1].expiration),
            format: "full",
            timeZoneName: "short"
          }))));
          break;

        case "limit_order_cancel":
          color = "cancel";
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transaction.order_id"
          })), /*#__PURE__*/React.createElement("td", null, op[1].order)));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.block.fee_payer"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].fee_paying_account))));
          break;

        case "short_order_cancel":
          color = "cancel";
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transaction.order_id"
          })), /*#__PURE__*/React.createElement("td", null, op[1].order)));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.block.fee_payer"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].fee_paying_account))));
          break;

        case "call_order_update":
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transaction.funding_account"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].funding_account))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transaction.delta_collateral"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedAsset, {
            amount: op[1].delta_collateral.amount,
            asset: op[1].delta_collateral.asset_id
          }))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transaction.delta_debt"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedAsset, {
            amount: op[1].delta_debt.amount,
            asset: op[1].delta_debt.asset_id
          }))));

          if (!!op[1].extensions && !!op[1].extensions.target_collateral_ratio) {
            rows.push( /*#__PURE__*/React.createElement("tr", {
              key: key++
            }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
              component: "span",
              content: "transaction.collateral_target"
            })), /*#__PURE__*/React.createElement("td", null, op[1].extensions.target_collateral_ratio / 1000)));
          }

          break;

        case "key_create":
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.block.fee_payer"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].fee_paying_account))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.block.key"
          })), /*#__PURE__*/React.createElement("td", null, op[1].key_data[1])));
          break;

        case "account_create":
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "account.name"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].name))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "account.member.registrar"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].registrar))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "account.member.lifetime_referrer"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].referrer))));
          break;

        case "account_update":
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "account.name"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].account)))); // let voting_account = ChainStore.getAccount(op[1].new_options.voting_account)
          // let updating_account = ChainStore.getAccount(op[1].account)

          if (op[1].new_options) {
            if (op[1].new_options.voting_account) {
              // let proxy_account_name = voting_account.get('name')
              rows.push( /*#__PURE__*/React.createElement("tr", {
                key: key++
              }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
                component: "span",
                content: "account.votes.proxy"
              })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].new_options.voting_account))));
            } else {
              console.log("num witnesses: ", op[1].new_options.num_witness);
              console.log("===============> NEW: ", op[1].new_options);
              rows.push( /*#__PURE__*/React.createElement("tr", {
                key: key++
              }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
                component: "span",
                content: "account.votes.proxy"
              })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
                component: "span",
                content: "account.votes.no_proxy"
              }))));
              rows.push( /*#__PURE__*/React.createElement("tr", {
                key: key++
              }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
                component: "span",
                content: "account.options.num_committee"
              })), /*#__PURE__*/React.createElement("td", null, op[1].new_options.num_committee)));
              rows.push( /*#__PURE__*/React.createElement("tr", {
                key: key++
              }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
                component: "span",
                content: "account.options.num_witnesses"
              })), /*#__PURE__*/React.createElement("td", null, op[1].new_options.num_witness)));
              rows.push( /*#__PURE__*/React.createElement("tr", {
                key: key++
              }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
                component: "span",
                content: "account.options.votes"
              })), /*#__PURE__*/React.createElement("td", null, JSON.stringify(op[1].new_options.votes))));
            }

            rows.push( /*#__PURE__*/React.createElement("tr", {
              key: key++
            }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
              component: "span",
              content: "account.options.memo_key"
            })), /*#__PURE__*/React.createElement("td", null, op[1].new_options.memo_key.substring(0, 10) + "...")));
          }

          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.block.common_options"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Inspector, {
            data: op[1],
            search: false
          }))));
          break;

        case "account_whitelist":
          let listing;

          for (var i = 0; i < listings.length; i++) {
            if (account_constants.account_listing[listings[i]] === op[1].new_listing) {
              console.log("listings:", listings[i]);
              listing = listings[i];
            }
          }

          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.block.authorizing_account"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].authorizing_account))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.block.listed_account"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].account_to_list))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.block.new_listing"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            content: `transaction.whitelist_states.${listing}`
          }))));
          break;

        case "account_upgrade":
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.block.account_upgrade"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].account_to_upgrade))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.block.lifetime"
          })), /*#__PURE__*/React.createElement("td", null, op[1].upgrade_to_lifetime_member.toString())));
          break;

        case "account_transfer":
          /* This case is uncomplete, needs filling out with proper fields */
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transfer.from"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].account_id))));
          break;

        case "asset_create":
          color = "warning";
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.assets.issuer"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].issuer))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.assets.symbol"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAsset(op[1].symbol))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.assets.precision"
          })), /*#__PURE__*/React.createElement("td", null, op[1].precision)));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "account.user_issued_assets.max_supply"
          })), /*#__PURE__*/React.createElement("td", null, utils.format_asset(op[1].common_options.max_supply, op[1]))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "account.user_issued_assets.description"
          })), /*#__PURE__*/React.createElement("td", null, op[1].common_options.description)));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transaction.market_fee"
          })), /*#__PURE__*/React.createElement("td", null, op[1].common_options.market_fee_percent / 100, "%")));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transaction.max_market_fee"
          })), /*#__PURE__*/React.createElement("td", null, utils.format_asset(op[1].common_options.max_market_fee, op[1]))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.block.common_options"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Inspector, {
            data: op[1],
            search: false
          }))));
          break;

        case "asset_update":
        case "asset_update_bitasset":
          console.log("op:", op);
          color = "warning";
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.block.asset_update"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAsset(op[1].asset_to_update))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.assets.issuer"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].issuer))));

          if (op[1].new_issuer !== op[1].issuer) {
            rows.push( /*#__PURE__*/React.createElement("tr", {
              key: key++
            }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
              component: "span",
              content: "account.user_issued_assets.new_issuer"
            })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].new_issuer))));
          }

          if (op[1].new_options.core_exchange_rate) {
            rows.push( /*#__PURE__*/React.createElement("tr", {
              key: key++
            }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
              component: "span",
              content: "markets.core_rate"
            })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedPrice, {
              base_asset: op[1].new_options.core_exchange_rate.base.asset_id,
              quote_asset: op[1].new_options.core_exchange_rate.quote.asset_id,
              base_amount: op[1].new_options.core_exchange_rate.base.amount,
              quote_amount: op[1].new_options.core_exchange_rate.quote.amount,
              noPopOver: true
            }))));
          }

          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.block.new_options"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Inspector, {
            data: op[1].new_options,
            search: false
          }))));
          break;

        case "asset_update_feed_producers":
          color = "warning";
          console.log("op:", op);
          let producers = [];
          op[1].new_feed_producers.forEach(producer => {
            // let missingAsset = this.getAccounts([producer])[0];
            producers.push( /*#__PURE__*/React.createElement("div", null, this.linkToAccount(producer), /*#__PURE__*/React.createElement("br", null)));
          });
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.block.asset_update"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAsset(op[1].asset_to_update))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.block.new_producers"
          })), /*#__PURE__*/React.createElement("td", null, producers)));
          break;

        case "asset_issue":
          color = "warning";

          if (op[1].memo) {
            let {
              text,
              isMine
            } = PrivateKeyStore.decodeMemo(op[1].memo);
            memo = text ? /*#__PURE__*/React.createElement("td", null, text) : !text && isMine ? /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
              content: "transfer.memo_unlock"
            }), "\xA0", /*#__PURE__*/React.createElement("a", {
              onClick: this._toggleLock.bind(this)
            }, /*#__PURE__*/React.createElement(Icon, {
              name: "locked",
              title: "icons.locked.action"
            }))) : null;
          }

          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.assets.issuer"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].issuer))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.block.asset_issue"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedAsset, {
            style: {
              fontWeight: "bold"
            },
            amount: op[1].asset_to_issue.amount,
            asset: op[1].asset_to_issue.asset_id
          }))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transfer.to"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].issue_to_account))));
          {
            memo ? rows.push( /*#__PURE__*/React.createElement("tr", {
              key: key++
            }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
              content: "transfer.memo"
            })), memo)) : null;
          }
          break;

        case "asset_burn":
          color = "cancel";
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.account.title"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].payer))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transfer.amount"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedAsset, {
            amount: op[1].amount_to_burn.amount,
            asset: op[1].amount_to_burn.asset_id
          }))));
          break;

        case "asset_fund_fee_pool":
          color = "warning";
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.account.title"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].from_account))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.asset.title"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAsset(op[1].asset_id))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transfer.amount"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedAsset, {
            amount: op[1].amount,
            asset: "1.3.0"
          }))));
          break;

        case "asset_settle":
          color = "warning";
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.account.title"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].account))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.asset.title"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAsset(op[1].amount.asset_id))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transfer.amount"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedAsset, {
            amount: op[1].amount.amount,
            asset: op[1].amount.asset_id
          }))));
          break;

        case "asset_publish_feed":
          color = "warning";
          let {
            feed
          } = op[1];
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transaction.publisher"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].publisher))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.asset.title"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAsset(op[1].asset_id))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.asset.price_feed.maximum_short_squeeze_ratio"
          })), /*#__PURE__*/React.createElement("td", null, (feed.maximum_short_squeeze_ratio / 1000).toFixed(2))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.asset.price_feed.maintenance_collateral_ratio"
          })), /*#__PURE__*/React.createElement("td", null, (feed.maintenance_collateral_ratio / 1000).toFixed(2))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "markets.core_rate"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedPrice, {
            base_asset: feed.core_exchange_rate.base.asset_id,
            quote_asset: feed.core_exchange_rate.quote.asset_id,
            base_amount: feed.core_exchange_rate.base.amount,
            quote_amount: feed.core_exchange_rate.quote.amount,
            noPopOver: true
          }))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.block.feed_price"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedPrice, {
            base_asset: asset_utils.extractRawFeedPrice(feed).base.asset_id,
            quote_asset: asset_utils.extractRawFeedPrice(feed).quote.asset_id,
            base_amount: asset_utils.extractRawFeedPrice(feed).base.amount,
            quote_amount: asset_utils.extractRawFeedPrice(feed).quote.amount,
            noPopOver: true
          }))));
          break;

        case "committee_member_create":
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.committee_member.title"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].committee_member_account))));
          break;

        case "witness_create":
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.block.witness"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].witness_account))));
          break;

        case "witness_update":
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.block.witness"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].witness_account))));

          if (op[1].new_url) {
            rows.push( /*#__PURE__*/React.createElement("tr", {
              key: key++
            }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
              component: "span",
              content: "transaction.new_url"
            })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("a", {
              href: op[1].new_url,
              target: "_blank",
              rel: "noopener noreferrer"
            }, op[1].new_url))));
          }

          break;

        case "balance_claim":
          color = "success";
          let bal_id = op[1].balance_to_claim.substring(5); // console.log( "bal_id: ", bal_id, op[1].balance_to_claim );

          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transaction.claimed"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedAsset, {
            amount: op[1].total_claimed.amount,
            asset: op[1].total_claimed.asset_id
          }))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transaction.deposit_to"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].deposit_to_account))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transaction.balance_id"
          })), /*#__PURE__*/React.createElement("td", null, "#", bal_id)));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transaction.balance_owner"
          })), /*#__PURE__*/React.createElement("td", {
            style: {
              fontSize: "80%"
            }
          }, op[1].balance_owner_key.substring(0, 10), "...")));
          break;

        case "vesting_balance_withdraw":
          color = "success";
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transfer.to"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].owner))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transfer.amount"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedAsset, {
            amount: op[1].amount.amount,
            asset: op[1].amount.asset_id
          }))));
          break;

        case "transfer_to_blind":
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transfer.from"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].from))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transfer.amount"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedAsset, {
            amount: op[1].amount.amount,
            asset: op[1].amount.asset_id
          }))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transaction.blinding_factor"
          })), /*#__PURE__*/React.createElement("td", {
            style: {
              fontSize: "80%"
            }
          }, op[1].blinding_factor)));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transaction.outputs"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Inspector, {
            data: op[1].outputs[0],
            search: false
          }))));
          break;

        case "transfer_from_blind":
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transfer.to"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].to))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transfer.amount"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedAsset, {
            amount: op[1].amount.amount,
            asset: op[1].amount.asset_id
          }))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transaction.blinding_factor"
          })), /*#__PURE__*/React.createElement("td", {
            style: {
              fontSize: "80%"
            }
          }, op[1].blinding_factor)));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transaction.inputs"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Inspector, {
            data: op[1].inputs[0],
            search: false
          }))));
          break;

        case "blind_transfer":
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transaction.inputs"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Inspector, {
            data: op[1].inputs[0],
            search: false
          }))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transaction.outputs"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Inspector, {
            data: op[1].outputs[0],
            search: false
          }))));
          break;

        case "proposal_create":
          var expiration_date = new Date(op[1].expiration_time + "Z");
          var has_review_period = op[1].review_period_seconds !== undefined;
          var review_begin_time = !has_review_period ? null : expiration_date.getTime() - op[1].review_period_seconds * 1000;
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "proposal_create.review_period"
          })), /*#__PURE__*/React.createElement("td", null, has_review_period ? /*#__PURE__*/React.createElement(FormattedDate, {
            value: new Date(review_begin_time),
            format: "full"
          }) : /*#__PURE__*/React.createElement("span", null, "\u2014"))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "proposal_create.expiration_time"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedDate, {
            value: expiration_date,
            format: "full"
          }))));
          var operations = [];

          for (let pop of op[1].proposed_ops) operations.push(pop.op);

          let proposalsText = op[1].proposed_ops.map((o, index) => {
            return /*#__PURE__*/React.createElement(ProposedOperation, {
              key: index,
              index: index,
              op: o.op,
              inverted: false,
              hideFee: true,
              hideOpLabel: true,
              hideDate: true,
              proposal: true,
              collapsed: true
            });
          });
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "proposal_create.proposed_operations"
          })), /*#__PURE__*/React.createElement("td", null, proposalsText)));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "proposal_create.fee_paying_account"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].fee_paying_account))));
          break;

        case "proposal_update":
          let fields = ["active_approvals_to_add", "active_approvals_to_remove", "owner_approvals_to_add", "owner_approvals_to_remove", "key_approvals_to_add", "key_approvals_to_remove"];
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "proposal_create.fee_paying_account"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].fee_paying_account))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "proposal_create.id"
          })), /*#__PURE__*/React.createElement("td", null, op[1].proposal)));
          fields.forEach(field => {
            if (op[1][field].length) {
              rows.push( /*#__PURE__*/React.createElement("tr", {
                key: key++
              }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
                content: `proposal.update.${field}`
              })), /*#__PURE__*/React.createElement("td", null, op[1][field].map(value => {
                return /*#__PURE__*/React.createElement("div", {
                  key: value
                }, this.linkToAccount(value));
              }))));
            }
          });
          break;

        case "proposal_delete":
          color = "cancel";
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "proposal_create.fee_paying_account"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].fee_paying_account))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "proposal_delete.using_owner_authority"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(TranslateBoolean, {
            value: op[1].using_owner_authority
          }))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "proposal_create.id"
          })), /*#__PURE__*/React.createElement("td", null, op[1].proposal)));
          break;

        case "asset_claim_fees":
          color = "success";
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transaction.claimed"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedAsset, {
            amount: op[1].amount_to_claim.amount,
            asset: op[1].amount_to_claim.asset_id
          }))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transaction.deposit_to"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].issuer))));
          break;

        case "asset_reserve":
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "modal.reserve.from"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].payer))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.asset.title"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAsset(op[1].amount_to_reserve.asset_id))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transfer.amount"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedAsset, {
            amount: op[1].amount_to_reserve.amount,
            asset: op[1].amount_to_reserve.asset_id
          }))));
          break;

        case "worker_create":
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.workers.title"
          })), /*#__PURE__*/React.createElement("td", null, op[1].name)));
          let startDate = counterpart.localize(new Date(op[1].work_begin_date), {
            type: "date"
          });
          let endDate = counterpart.localize(new Date(op[1].work_end_date), {
            type: "date"
          });
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.workers.period"
          })), /*#__PURE__*/React.createElement("td", null, startDate, " - ", endDate)));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.workers.daily_pay"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedAsset, {
            amount: op[1].daily_pay,
            asset: "1.3.0"
          }))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.workers.website"
          })), /*#__PURE__*/React.createElement("td", null, utils.sanitize(op[1].url))));

          if (op[1].initializer[1]) {
            rows.push( /*#__PURE__*/React.createElement("tr", {
              key: key++
            }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
              component: "span",
              content: "explorer.workers.vesting_pay"
            })), /*#__PURE__*/React.createElement("td", null, op[1].initializer[1].pay_vesting_period_days)));
          }

          break;

        case "asset_claim_pool":
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "account.name"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(LinkToAccountById, {
            account: op[1].issuer
          }))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.asset.title"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(LinkToAssetById, {
            asset: op[1].asset_id
          }))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transfer.amount"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedAsset, {
            amount: op[1].amount_to_claim.amount,
            asset: op[1].amount_to_claim.asset_id
          }))));
          break;

        case "asset_update_issuer":
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transfer.from"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(LinkToAccountById, {
            account: op[1].issuer
          }))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transfer.to"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(LinkToAccountById, {
            account: op[1].new_issuer
          }))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.asset.title"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(LinkToAssetById, {
            asset: op[1].asset_to_update
          }))));
          break;

        case "bid_collateral":
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.account.title"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(LinkToAccountById, {
            account: op[1].bidder
          }))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.asset.collateral_bid.collateral"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedAsset, {
            asset: op[1].additional_collateral.asset_id,
            amount: op[1].additional_collateral.amount
          }))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.asset.collateral_bid.debt"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedAsset, {
            asset: op[1].debt_covered.asset_id,
            amount: op[1].debt_covered.amount
          }))));
          break;

        case "htlc_create":
          // add claim period to block time
          const block_time = this.props.block ? this.props.block.timestamp.getTime() : new Date().getTime();
          let claim_due = new Date(block_time + op[1].claim_period_seconds * 1000);
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transfer.from"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(LinkToAccountById, {
            account: op[1].from
          }))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transfer.to"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(LinkToAccountById, {
            account: op[1].to
          }))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "transfer.amount"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedAsset, {
            amount: op[1].amount.amount,
            asset: op[1].amount.asset_id
          }))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "htlc.claim_period_due"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(FormattedDate, {
            value: claim_due,
            format: "full"
          }))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "htlc.preimage_hash"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Tooltip, {
            placement: "bottom",
            title: counterpart.translate("htlc.preimage_hash_explanation")
          }, /*#__PURE__*/React.createElement("span", null, "(" + op[1].preimage_size + ", " + op[1].preimage_hash[0] + "): " + op[1].preimage_hash[1])))));
          break;

        case "htlc_redeem":
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "htlc.id"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", null, op[1].htlc_id))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "htlc.redeemer"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].redeemer))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "htlc.preimage"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].preimage))));
          break;

        case "htlc_extend":
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "htlc.id"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", null, op[1].htlc_id))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "htlc.update_issuer"
          })), /*#__PURE__*/React.createElement("td", null, this.linkToAccount(op[1].update_issuer))));
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "htlc.seconds_to_add"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("span", null, op[1].seconds_to_add))));
          break;

        default:
          console.log("unimplemented tx op:", op);
          rows.push( /*#__PURE__*/React.createElement("tr", {
            key: key++
          }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Translate, {
            component: "span",
            content: "explorer.block.op"
          })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Inspector, {
            data: op,
            search: false
          }))));
          break;
      }

      info.push( /*#__PURE__*/React.createElement(OperationTable, {
        txIndex: this.props.index,
        key: opIndex,
        opCount: opCount,
        index: opIndex,
        color: color,
        operation: op
      }, rows));
    });
    return /*#__PURE__*/React.createElement("div", null, info);
  }

}

Transaction.defaultProps = {
  no_links: false
};
Transaction.propTypes = {
  trx: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  no_links: PropTypes.bool
};
export default Transaction;